export default class IpUserInfo {
    [x: string]: any;
 	 static $inject = ['$q'];
    constructor($q) {
        this.defaultCountry = "US";
        this.ipUserInfo = {};
        this.$q = $q.defer();
    }

    getIpInfo() {
        //Why fetch? angular resource cuts '/' which causes 404 error
        return fetch('https://laowotcchk.execute-api.eu-west-1.amazonaws.com/prod/geo-ip')
            .then((res) => res.json())
            .then((json) => {
                this.ipUserInfo = json;
                this.$q.resolve()
            })
            .catch(() => this.$q.resolve())
    }

    isReady() {
        return this.$q.promise;
    }

    getCountry() {
        return this.ipUserInfo.countryCode || this.defaultCountry;
    }

}
